import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'
import { MatDialog } from '@angular/material/dialog';
import { merge, Observable, of } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { NotificationDTO } from '../../../../../interfaces/notificationDTO';
import { NotificationUiService } from '../../../../../providers/notification/notification.ui.service';
import { DestroyableComponent } from '../../../../utils/destroyable.component';
import { ViewNotificationDialogComponent } from './view-notification-dialog/view-notification-dialog.component';

@Component({
  selector: 'app-bell-notification-view',
  templateUrl: './bell-notification-view.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BellNotificationViewComponent extends DestroyableComponent implements OnInit {

  constructor(
    private readonly notificationUiService: NotificationUiService,
    private readonly dialog: MatDialog) {
    super();
  }

  notifications$: Observable<NotificationDTO[]>;
  notificaitonsCount$: Observable<number>;

  ngOnInit() {
    this.notifications$ = this.notificationUiService.getAllNotificaitonsHttp();
    this.notificaitonsCount$ = merge(of(0), this.notifications$.pipe(map(notifications => (notifications || []).length)));
  }

  deleteNotification(notificationToRemove: NotificationDTO) {
    of({}).pipe(
      tap(() => {
        let notifications = this.notificationUiService.currentValue;
        notifications = notifications.filter(notificaiton => notificationToRemove !== notificaiton);
        this.notificationUiService.addNotificationList(notifications);
      }),
      switchMap(() => this.notificationUiService.markAsViewed(notificationToRemove.id))
    ).subscribe();
  }

  viewNotification(notificationToView: NotificationDTO) {
    this.dialog.open(ViewNotificationDialogComponent, {
      width: '450px',
      data: {
        content: notificationToView.content,
      },
    });
  }
}

